export default {
	setPropertyData(state, data) {
		state.propertyData = data;
	},
  setOrderForm(state, data) {
    state.orderFormData = data;
  },
  setOrderFormEditable(state, data) {
    state.isOrderFromEditable = data;
  },
  // assign orderStatus
  setCaseData(state, data) {
    state.caseData = data;
  }
};
